module.exports = __webpack_public_path__ + "assets/media/video-mobile.8be9fae4.mp4";